import React, { useState } from 'react';
import { ReactComponent as DownloadIcon } from 'assets/download-icon.svg';
import { downloadTransactionDocument } from 'services/requestAgent';
import './styles.scss';

const FileDisplay = ({ files = [], comment = '', accountNumber, transactionNumber }) => {
  const [downloadingFiles, setDownloadingFiles] = useState(new Set());
  // Helper function to format file size
  const formatFileSize = (bytes) => {
    if (!bytes) return '0 B';
    const k = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
  };

  // Handle file download
  const handleDownload = async (file) => {
    if (!accountNumber || !transactionNumber || !file.id) return;

    setDownloadingFiles((prev) => new Set(prev).add(file.id));

    try {
      await downloadTransactionDocument(accountNumber, transactionNumber, file.id);
    } catch (error) {
      console.error('Failed to download file:', error);
    } finally {
      setDownloadingFiles((prev) => {
        const newSet = new Set(prev);
        newSet.delete(file.id);
        return newSet;
      });
    }
  };

  // Don't render if no files and no comment
  if (!files.length && !comment) return null;

  return (
    <div className='file-display-container'>
      {files.map((file, index) => (
        <div key={`${file.name}-${index}`} className='file-display-item'>
          <div className='file-info'>
            <button
              className={`file-icon-container ${downloadingFiles.has(file.id) ? 'downloading' : ''}`}
              onClick={() => handleDownload(file)}
              disabled={downloadingFiles.has(file.id) || !accountNumber || !transactionNumber}
              title={downloadingFiles.has(file.id) ? 'Downloading...' : 'Download file'}
            >
              <DownloadIcon className='file-icon' />
            </button>
            <div className='file-details'>
              <div className='file-name'>{file.name}</div>
              <div className='file-size'>{formatFileSize(file.size)}</div>
            </div>
          </div>
          {index === 0 && comment && <div className='file-comment'>{comment}</div>}
        </div>
      ))}
      {!files.length && comment && (
        <div className='file-display-item'>
          <div className='file-comment only-comment'>{comment}</div>
        </div>
      )}
    </div>
  );
};

export default FileDisplay;
